import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, filter, map, mergeMap, switchMap } from 'rxjs/operators';
import * as CustomLanguagesActions from './custom-languages.actions';
import { ValueSetService } from 'src/app/admin/value-set/value-set.service';
import { environment } from 'src/environments/environment';
import { Store } from '@ngrx/store';
import { filterObjectsWithId } from 'src/app/shared/utils/apollo-utils';
import { ValuesetItem } from 'src/app/shared/api/types/GraphQL';

@Injectable()
export class CustomLanguagesEffects {
  constructor(
    private actions$: Actions,
    private valuesetService: ValueSetService,
    private store: Store
  ) {}

  public readonly loadCustomLanguages$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomLanguagesActions.loadCustomLanguages),
      mergeMap(() =>
        this.valuesetService.getValuesetByName({ names: [environment.valuesetByName.dataLanguages] }).valueChanges.pipe(
          filter((result) => !result.loading && !!result.data),
          map((result) => result.data.valuesets.items[0]),
          switchMap((valueset) => {
            const valuesetId = valueset?.id;
            this.store.dispatch(CustomLanguagesActions.setCustomLanguagesValuesetId({ valuesetId }));
            return this.valuesetService.getValueSetItemList({ valuesetIds: [valuesetId] }).valueChanges.pipe(
              map((data) => data.data.valuesetItems.items),
              map((items) => filterObjectsWithId<ValuesetItem>(items)),
              map((valuesetItems) => CustomLanguagesActions.customLanguagesSuccess({ items: valuesetItems })),
              catchError((error) => of(CustomLanguagesActions.customLanguagesFailure({ error })))
            );
          })
        )
      )
    )
  );
}
